import React, { useEffect, useMemo } from 'react'
import { Typography } from 'antd'
import { includes, isNil } from 'lodash'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'

import { MENU_CURATION_TASK_STATUS } from '../../../menu-curation-tasks/constants'
import { useDishesProgressCountsLazyQuery } from '../../hooks'

const DishProgress = ({ taskStatus, menuId }) => {
  const [fetchCounts, { data, error }] = useDishesProgressCountsLazyQuery()

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Failed to get dishes progress counts ',
        description: error,
      })
    }
  }, [error])

  const isTaskInProgress = useMemo(
    () =>
      includes(
        [
          MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value,
          MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value,
          MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value,
          MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value,
        ],
        taskStatus,
      ),
    [taskStatus],
  )

  useEffect(() => {
    if (isTaskInProgress) {
      fetchCounts(menuId)
    }
  }, [fetchCounts, isTaskInProgress, menuId])

  if (
    !isTaskInProgress ||
    isNil(data.doneCount) ||
    isNil(data.availableForWorkCount)
  ) {
    return null
  }

  return (
    <Typography.Text>
      Dishes Progress ({data.doneCount}/{data.availableForWorkCount})
    </Typography.Text>
  )
}

DishProgress.propTypes = {
  menuId: PropTypes.number.isRequired,
  taskStatus: PropTypes.string.isRequired,
}

export default DishProgress
